import { styled } from "@mui/material/styles";
import Image from "next/image";

export const ImageContainer = styled("div")(({ theme }) => ({
  height: "100%",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  zIndex: "0",
  overflow: "hidden",
  backgroundColor: theme.colors["neutral.900"],
}));

export const StyledImage = styled(Image)(({ theme }) => ({
  objectFit: "cover",
  
  userSelect: 'none',
  MozUserSelect: 'none', 
  WebkitUserSelect: 'none', 
  msUserSelect: 'none', 
}));

export const Overlay = styled("div")(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1
}));